// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 퇴직정산 테이블 컴포넌트 스타일 - Salary 컴포넌트 스타일 참고 */
.employee-retirement-table {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  margin: 1rem 0;
}

/* 헤더 영역 */
.retirement-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #e1e5e9;
  background: #f8f9fa;
  gap: 1rem;
  min-height: 60px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.retirement-title-section {
  display: flex;
  align-items: center;
  gap: 0.3rem;
  flex: 1 1;
  flex-wrap: wrap;
}

.retirement-title-section h3 {
  margin: 0;
  color: #333;
  font-size: 1.1rem;
  word-break: break-word;
}

.header-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* 줌 컨트롤 */
.zoom-controls {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  padding: 0.25rem;
}

.zoom-btn {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  color: #495057;
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.zoom-btn:hover {
  background: #e9ecef;
  border-color: #adb5bd;
}

.zoom-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.zoom-level {
  font-size: 0.8rem;
  color: #495057;
  font-weight: 500;
  min-width: 40px;
  text-align: center;
}

/* 메타 정보 영역 */
.meta-section {
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
}

.meta-info {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  font-size: 0.85rem;
  color: #666;
}

.meta-info span {
  background: white;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  border: 1px solid #e1e5e9;
}

.hidden-columns-info {
  background: #fff3cd !important;
  border-color: #ffc107 !important;
  color: #856404 !important;
  font-weight: 500;
}

.selected-cells-info {
  background: #f8d7da !important;
  border-color: #dc3545 !important;
  color: #721c24 !important;
  font-weight: 600;
}

.selected-columns-info {
  background: #d1ecf1 !important;
  border-color: #17a2b8 !important;
  color: #0c5460 !important;
  font-weight: 600;
}

.retirement-net-price-info {
  background: #d4edda !important;
  border-color: #28a745 !important;
  color: #155724 !important;
  font-weight: 700;
  font-size: 0.9rem;
}

/* 퇴직금 컬럼 스타일 */
.retirement-column {
  background-color: #fff3cd !important;
  border-color: #ffc107 !important;
  color: #856404 !important;
  font-weight: 700 !important;
}

.retirement-cell {
  background-color: #fff3cd !important;
  border-color: #ffc107 !important;
  color: #856404 !important;
  font-weight: 600 !important;
}

.retirement-indicator {
  margin-left: 5px;
  font-size: 0.9rem;
}


/* 선택 불가능한 헤더와 셀 */
.non-clickable-header {
  cursor: default !important;
}

.non-clickable-header:hover {
  background: #f8f9fa !important;
  border-color: #dee2e6 !important;
}

.non-clickable-cell {
  cursor: default !important;
}

.non-clickable-cell:hover {
  background: inherit !important;
  border-color: inherit !important;
}

/* 테이블 영역 */
.retirement-table-display {
  flex: 1 1;
  overflow: auto;
  transform: scale(var(--zoom-level, 100) / 100);
  transform-origin: top left;
}

.retirement-table-container {
  width: 100%;
  overflow: auto;
  min-height: 400px;
}

.retirement-data-table {
  width: auto;
  border-collapse: collapse;
  font-size: 0.9rem;
  background: white;
  table-layout: auto;
}

.retirement-data-table th {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  padding: 0.6rem 0.4rem;
  text-align: left;
  font-weight: 600;
  color: #495057;
  position: sticky;
  top: 0;
  z-index: 10;
  white-space: nowrap;
  min-width: 100px;
  max-width: 150px;
}

.retirement-data-table td {
  border: 1px solid #dee2e6;
  padding: 0.4rem 0.3rem;
  text-align: right;
  color: #495057;
  white-space: nowrap;
  min-width: 80px;
  max-width: 120px;
}

.retirement-data-table td:first-child {
  text-align: left;
}

.retirement-data-table tbody tr:hover {
  background: #f8f9fa;
}

/* 클릭 가능한 셀 */
.clickable-cell {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.clickable-cell:hover {
  background: #e3f2fd !important;
  border-color: #2196f3 !important;
}

/* 선택된 셀 */
.selected-cell {
  background: #f8d7da !important;
  border: 2px solid #dc3545 !important;
  color: #721c24 !important;
  font-weight: 600;
  cursor: pointer;
  position: relative;
}

.selected-cell:hover {
  background: #f5c6cb !important;
}

.selected-cell::after {
  content: '✓';
  position: absolute;
  top: 2px;
  right: 2px;
  font-size: 10px;
  color: #dc3545;
  font-weight: bold;
}

/* 클릭 가능한 헤더 */
.clickable-header {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.clickable-header:hover {
  background: #e9ecef !important;
}

/* 선택된 컬럼 헤더 */
.selected-column {
  background: #d1ecf1 !important;
  border-color: #17a2b8 !important;
  color: #0c5460 !important;
  font-weight: 700;
}

.selected-column:hover {
  background: #bee5eb !important;
}

.column-selected-indicator {
  float: right;
  margin-left: 0.5rem;
  font-size: 0.8rem;
  color: #17a2b8;
  font-weight: bold;
}

.header-part {
  display: block;
  margin: 2px 0;
  font-size: 0.8rem;
  line-height: 1.2;
}

.sort-indicator {
  float: right;
  margin-left: 0.5rem;
  font-size: 0.8rem;
  color: #6c757d;
}

/* 합계 행 */
.totals-row {
  background: #f8f9fa !important;
  font-weight: 600;
}

.totals-row td {
  background: #f8f9fa !important;
  border-top: 2px solid #495057;
}

.totals-label {
  text-align: left !important;
  font-weight: 600;
  color: #495057;
}

.totals-cell {
  font-weight: 600;
  color: #495057;
}

/* 데이터 없음 메시지 */
.no-data-message {
  text-align: center;
  padding: 3rem;
  color: #666;
}

.no-data-message h3 {
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 1.2rem;
}

.no-data-message p {
  margin: 0;
  color: #666;
  font-size: 0.9rem;
}

/* 테이블 푸터 */
.table-footer {
  padding: 0.75rem 1rem;
  background: #f8f9fa;
  border-top: 1px solid #e1e5e9;
}

.footer-info {
  font-size: 0.8rem;
  color: #666;
  text-align: center;
}

.footer-info p {
  margin: 0.25rem 0;
}

.clear-selection-btn {
  background: #dc3545;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 500;
  margin-top: 0.5rem;
  transition: background-color 0.2s ease;
}

.clear-selection-btn:hover {
  background: #c82333;
}

/* 반응형 디자인 */
@media (max-width: 768px) {
  .retirement-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .header-buttons {
    width: 100%;
    justify-content: flex-end;
  }
  
  .meta-info {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .retirement-data-table {
    font-size: 0.8rem;
  }
  
  .retirement-data-table th,
  .retirement-data-table td {
    padding: 0.4rem 0.3rem;
    min-width: 80px;
  }
}

/* 담기 버튼 스타일 */
.cart-actions {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e1e5e9;
}

.add-to-cart-btn {
  width: 100%;
  background: #28a745;
  color: white;
  border: none;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}

.add-to-cart-btn:hover:not(:disabled) {
  background: #218838;
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);
}

.add-to-cart-btn:disabled {
  background: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* 스크롤바 스타일링 */
.retirement-table-container::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.retirement-table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.retirement-table-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.retirement-table-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
/* ── DC 부담금: 총 부담금 배지 / 재직 메타 / 경고 ── */
.total-contribution-info {
  background: #cfe2ff !important;
  border-color: #0d6efd !important;
  color: #084298 !important;
  font-weight: 700;
  font-size: 0.9rem;
}

.employment-meta {
  margin-top: 0.4rem;
}

.no-leave-warning {
  background: #fff3cd !important;
  border-color: #ffc107 !important;
  color: #856404 !important;
  font-weight: 600;
}

/* ── 연도별 부담금 정산 패널 (표 가운데 정렬) ── */
.yearly-summary-panel {
  margin: 0.75rem 0;
  overflow-x: auto;
  display: flex;
  justify-content: center;
}

.yearly-summary-table {
  border-collapse: collapse;
  font-size: 0.85rem;
  min-width: 420px;
  background: white;
  margin: 0 auto;
}

.yearly-summary-table th,
.yearly-summary-table td {
  border: 1px solid #dee2e6;
  padding: 0.35rem 0.75rem;
  text-align: center;
}

.yearly-summary-table th {
  background: #f8f9fa;
  color: #495057;
  font-weight: 600;
}

.yearly-summary-table td.num {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.yearly-summary-table tfoot td {
  background: #e7f1ff;
  font-weight: 700;
}

.inherited-tag {
  display: inline-block;
  margin-left: 6px;
  padding: 0 5px;
  font-size: 0.7rem;
  font-weight: 600;
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  vertical-align: middle;
  white-space: nowrap;
}

/* ── 산입 컬럼 (월별 산입분, 클릭 수정) ── */
.share-column-header {
  background: #e7f1ff !important;
  min-width: 72px;
  width: 72px;
}

.share-cell {
  min-width: 72px;
  width: 72px;
  text-align: center;
  cursor: pointer;
  background: #f4f8ff;
  font-variant-numeric: tabular-nums;
}

.share-cell:hover {
  background: #dbe9ff;
}

.share-cell.overridden {
  background: #fff3cd;
  font-weight: 700;
  color: #856404;
}

.share-cell.editing {
  padding: 2px;
}

.share-cell.editing input {
  width: 100%;
  border: 2px solid #0d6efd;
  border-radius: 3px;
  padding: 2px 4px;
  font-size: inherit;
  text-align: center;
}

.override-mark {
  margin-left: 3px;
  font-size: 0.75rem;
}

.share-cell.totals-cell {
  cursor: default;
  font-weight: 700;
  background: #e7f1ff;
}

/* ── 비고 컬럼 (월별 산입 사유 / 연도별 승계) ── */
.share-note-header {
  background: #f8f9fa !important;
  min-width: 160px;
}

/* .retirement-data-table td 의 nowrap/max-width(120px)보다 명시도를 높여야 적용됨 */
.retirement-data-table td.share-note-cell {
  min-width: 200px;
  max-width: none;
  font-size: 0.78rem;
  color: #6c757d;
  text-align: left;
  white-space: normal;   /* 내용 잘림 방지 — 줄바꿈 허용 */
  word-break: keep-all;  /* 한글 어절 단위 줄바꿈 */
  line-height: 1.4;
}

.yearly-summary-table td.note {
  text-align: left;
  font-size: 0.8rem;
  color: #6c757d;
  min-width: 160px;
}

/* ── 해당월 임금대장 보기 (좌측 컬럼) ── */
.ledger-link-header {
  background: #f8f9fa !important;
  min-width: 52px;
  width: 52px;
}

.retirement-data-table td.ledger-link-cell {
  min-width: 52px;
  width: 52px;
  text-align: center;
}

.ledger-link-btn {
  display: inline-block;
  padding: 1px 8px;
  font-size: 0.75rem;
  color: #0d6efd;
  background: #e7f1ff;
  border: 1px solid #b6d4fe;
  border-radius: 8px;
  text-decoration: none;
  white-space: nowrap;
}

.ledger-link-btn:hover {
  background: #cfe2ff;
}

/* ── 연도 경계 굵은 선 (해가 바뀌는 행 위쪽) ── */
.retirement-data-table tr.year-boundary td {
  border-top: 3px solid #495057;
}

/* ── 가상 월 행 (입사/퇴사년도 근무기간 외) ── */
.retirement-data-table tr.virtual-month-row td.virtual-cell {
  background: #fafbfc;
  color: #adb5bd;
  font-style: italic;
}

/* 퇴사일이 없는 직원의 퇴사 예정일: 눈에 띄게 */
.planned-leave-panel { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin: 10px 0; padding: 12px 16px; border: 2px solid #e8590c; border-radius: 10px; background: #fff4e6; }
.planned-leave-panel.set { border-color: #1864ab; background: #e7f1fb; }
.planned-leave-panel > div { display: flex; flex-direction: column; gap: 3px; flex: 1 1; min-width: 260px; }
.planned-leave-panel b { color: #9a4b00; font-size: 15px; }
.planned-leave-panel.set b { color: #0b3d6b; }
.planned-leave-panel span { color: #495057; font-size: 13px; }
.planned-leave-panel label { display: flex; align-items: center; gap: 8px; font-weight: 700; }
.planned-leave-panel input { height: 34px; padding: 0 10px; border: 2px solid #e8590c; border-radius: 6px; font: inherit; font-size: 14px; }
.planned-leave-panel.set input { border-color: #1864ab; }
.planned-leave-panel button { height: 34px; padding: 0 12px; border: 1px solid #adb5bd; border-radius: 6px; background: #fff; cursor: pointer; }

/* 산식(한 번만)과 휴직 내역 */
/* 산식: 분수 모양, 기호는 수식체 */
.yearly-formula { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 18px; margin-bottom: 10px; padding: 8px 12px; border-radius: 8px; background: #f6f8fb; }
.dc-math { display: inline-flex; align-items: center; gap: 4px; font-family: 'Cambria Math', 'Cambria', 'Times New Roman', serif; font-variant-numeric: tabular-nums; }
.dc-main { color: #0b3d6b; font-size: 17px; }
.dc-word { font-family: 'Malgun Gothic', sans-serif; font-size: 14px; font-weight: 700; }
.dc-var { font-style: italic; font-weight: 600; }
.dc-frac { display: inline-flex; flex-direction: column; align-items: stretch; margin: 0 3px; text-align: center; vertical-align: middle; line-height: 1.2; }
.dc-num { padding: 0 5px 2px; border-bottom: 1.5px solid currentColor; }
.dc-den { padding: 2px 5px 0; }
.dc-legend { display: inline-flex; flex-wrap: wrap; gap: 4px 12px; color: #495057; font-size: 12px; }
.dc-legend .dc-var { margin-right: 3px; color: #0b3d6b; font-family: 'Cambria Math', 'Times New Roman', serif; font-size: 14px; }
.dc-cases { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 4px; color: #6c757d; font-size: 12px; }
.dc-cases .dc-math { font-size: 13px; color: #495057; }
/* 연도별 칸: 같은 모양을 작게(행 높이를 크게 늘리지 않게) */
.dc-cell { font-size: 11.5px; line-height: 1.1; color: #343a40; }
.dc-cell b { font-family: 'Malgun Gothic', sans-serif; font-size: 12.5px; color: #0b3d6b; }
.dc-cell .dc-num { padding-bottom: 1px; border-bottom-width: 1px; }
.dc-cell .dc-den { padding-top: 1px; }
.dc-note { margin-right: 4px; font-family: 'Malgun Gothic', sans-serif; color: #6c757d; font-size: 11px; }
.leave-history-panel { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 10px; margin: 10px 0; padding: 8px 12px; border: 1px solid #ffe066; border-radius: 8px; background: #fffbe6; }
.leave-history-panel b { color: #5c4a00; }
.leave-chip { padding: 2px 10px; border-radius: 12px; background: #fff3bf; color: #5c4a00; font-weight: 600; font-variant-numeric: tabular-nums; }
.leave-history-note { color: #6c757d; font-size: 12px; }
`, "",{"version":3,"sources":["webpack://./src/components/EmployeeRetirementTable.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,gCAAgC;EAChC,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA,kBAAkB;AAClB;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,WAAW;AACX;EACE,SAAO;EACP,cAAc;EACd,8CAA8C;EAC9C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA,UAAU;AACV;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;IACtB,eAAe;EACjB;AACF;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,cAAc;AACd;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA,wCAAwC;AACxC;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oCAAoC;AACpC;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,uEAAuE;AACvE;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB,IAAI,sBAAsB;EAC7C,oBAAoB,GAAG,iBAAiB;EACxC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,6BAA6B;AAC/B;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AAChM,2BAA2B,qBAAqB,EAAE,mBAAmB,EAAE;AACvE,6BAA6B,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE,SAAO,EAAE,gBAAgB,EAAE;AACzG,yBAAyB,cAAc,EAAE,eAAe,EAAE;AAC1D,6BAA6B,cAAc,EAAE;AAC7C,4BAA4B,cAAc,EAAE,eAAe,EAAE;AAC7D,6BAA6B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gBAAgB,EAAE;AAC7F,6BAA6B,YAAY,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,eAAe,EAAE;AAC3I,iCAAiC,qBAAqB,EAAE;AACxD,8BAA8B,YAAY,EAAE,eAAe,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,eAAe,EAAE;;AAE/I,oBAAoB;AACpB,uBAAuB;AACvB,kBAAkB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,aAAa,EAAE,mBAAmB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AACvK,WAAW,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE,gEAAgE,EAAE,kCAAkC,EAAE;AACtK,WAAW,cAAc,EAAE,eAAe,EAAE;AAC5C,WAAW,wCAAwC,EAAE,eAAe,EAAE,gBAAgB,EAAE;AACxF,UAAU,kBAAkB,EAAE,gBAAgB,EAAE;AAChD,WAAW,oBAAoB,EAAE,sBAAsB,EAAE,oBAAoB,EAAE,aAAa,EAAE,kBAAkB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC5J,UAAU,kBAAkB,EAAE,uCAAuC,EAAE;AACvE,UAAU,kBAAkB,EAAE;AAC9B,aAAa,oBAAoB,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,eAAe,EAAE;AACpG,qBAAqB,iBAAiB,EAAE,cAAc,EAAE,qDAAqD,EAAE,eAAe,EAAE;AAChI,YAAY,oBAAoB,EAAE,mBAAmB,EAAE,eAAe,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE;AACnH,qBAAqB,eAAe,EAAE,cAAc,EAAE;AACtD,sCAAsC;AACtC,WAAW,iBAAiB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AAChE,aAAa,wCAAwC,EAAE,iBAAiB,EAAE,cAAc,EAAE;AAC1F,mBAAmB,mBAAmB,EAAE,wBAAwB,EAAE;AAClE,mBAAmB,gBAAgB,EAAE;AACrC,WAAW,iBAAiB,EAAE,wCAAwC,EAAE,cAAc,EAAE,eAAe,EAAE;AACzG,uBAAuB,aAAa,EAAE,mBAAmB,EAAE,eAAe,EAAE,aAAa,EAAE,cAAc,EAAE,iBAAiB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAClM,yBAAyB,cAAc,EAAE;AACzC,cAAc,iBAAiB,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,cAAc,EAAE,gBAAgB,EAAE,kCAAkC,EAAE;AACjJ,sBAAsB,cAAc,EAAE,eAAe,EAAE","sourcesContent":["/* 퇴직정산 테이블 컴포넌트 스타일 - Salary 컴포넌트 스타일 참고 */\r\n.employee-retirement-table {\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  margin: 1rem 0;\r\n}\r\n\r\n/* 헤더 영역 */\r\n.retirement-header {\r\n  display: flex;\r\n  align-items: center;\r\n  padding: 0.75rem 1rem;\r\n  border-bottom: 1px solid #e1e5e9;\r\n  background: #f8f9fa;\r\n  gap: 1rem;\r\n  min-height: 60px;\r\n  flex-wrap: wrap;\r\n  justify-content: space-between;\r\n}\r\n\r\n.retirement-title-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.3rem;\r\n  flex: 1;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.retirement-title-section h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.1rem;\r\n  word-break: break-word;\r\n}\r\n\r\n.header-buttons {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* 줌 컨트롤 */\r\n.zoom-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.25rem;\r\n  background: white;\r\n  border: 1px solid #dee2e6;\r\n  border-radius: 6px;\r\n  padding: 0.25rem;\r\n}\r\n\r\n.zoom-btn {\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  color: #495057;\r\n  font-size: 0.8rem;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  min-width: 28px;\r\n  height: 28px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.zoom-btn:hover {\r\n  background: #e9ecef;\r\n  border-color: #adb5bd;\r\n}\r\n\r\n.zoom-btn:disabled {\r\n  opacity: 0.5;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.zoom-level {\r\n  font-size: 0.8rem;\r\n  color: #495057;\r\n  font-weight: 500;\r\n  min-width: 40px;\r\n  text-align: center;\r\n}\r\n\r\n/* 메타 정보 영역 */\r\n.meta-section {\r\n  padding: 0.75rem 1rem;\r\n  background: #f8f9fa;\r\n  border-bottom: 1px solid #e1e5e9;\r\n}\r\n\r\n.meta-info {\r\n  display: flex;\r\n  gap: 1rem;\r\n  flex-wrap: wrap;\r\n  font-size: 0.85rem;\r\n  color: #666;\r\n}\r\n\r\n.meta-info span {\r\n  background: white;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 4px;\r\n  border: 1px solid #e1e5e9;\r\n}\r\n\r\n.hidden-columns-info {\r\n  background: #fff3cd !important;\r\n  border-color: #ffc107 !important;\r\n  color: #856404 !important;\r\n  font-weight: 500;\r\n}\r\n\r\n.selected-cells-info {\r\n  background: #f8d7da !important;\r\n  border-color: #dc3545 !important;\r\n  color: #721c24 !important;\r\n  font-weight: 600;\r\n}\r\n\r\n.selected-columns-info {\r\n  background: #d1ecf1 !important;\r\n  border-color: #17a2b8 !important;\r\n  color: #0c5460 !important;\r\n  font-weight: 600;\r\n}\r\n\r\n.retirement-net-price-info {\r\n  background: #d4edda !important;\r\n  border-color: #28a745 !important;\r\n  color: #155724 !important;\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* 퇴직금 컬럼 스타일 */\r\n.retirement-column {\r\n  background-color: #fff3cd !important;\r\n  border-color: #ffc107 !important;\r\n  color: #856404 !important;\r\n  font-weight: 700 !important;\r\n}\r\n\r\n.retirement-cell {\r\n  background-color: #fff3cd !important;\r\n  border-color: #ffc107 !important;\r\n  color: #856404 !important;\r\n  font-weight: 600 !important;\r\n}\r\n\r\n.retirement-indicator {\r\n  margin-left: 5px;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n\r\n/* 선택 불가능한 헤더와 셀 */\r\n.non-clickable-header {\r\n  cursor: default !important;\r\n}\r\n\r\n.non-clickable-header:hover {\r\n  background: #f8f9fa !important;\r\n  border-color: #dee2e6 !important;\r\n}\r\n\r\n.non-clickable-cell {\r\n  cursor: default !important;\r\n}\r\n\r\n.non-clickable-cell:hover {\r\n  background: inherit !important;\r\n  border-color: inherit !important;\r\n}\r\n\r\n/* 테이블 영역 */\r\n.retirement-table-display {\r\n  flex: 1;\r\n  overflow: auto;\r\n  transform: scale(var(--zoom-level, 100) / 100);\r\n  transform-origin: top left;\r\n}\r\n\r\n.retirement-table-container {\r\n  width: 100%;\r\n  overflow: auto;\r\n  min-height: 400px;\r\n}\r\n\r\n.retirement-data-table {\r\n  width: auto;\r\n  border-collapse: collapse;\r\n  font-size: 0.9rem;\r\n  background: white;\r\n  table-layout: auto;\r\n}\r\n\r\n.retirement-data-table th {\r\n  background: #f8f9fa;\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.6rem 0.4rem;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #495057;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n  white-space: nowrap;\r\n  min-width: 100px;\r\n  max-width: 150px;\r\n}\r\n\r\n.retirement-data-table td {\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.4rem 0.3rem;\r\n  text-align: right;\r\n  color: #495057;\r\n  white-space: nowrap;\r\n  min-width: 80px;\r\n  max-width: 120px;\r\n}\r\n\r\n.retirement-data-table td:first-child {\r\n  text-align: left;\r\n}\r\n\r\n.retirement-data-table tbody tr:hover {\r\n  background: #f8f9fa;\r\n}\r\n\r\n/* 클릭 가능한 셀 */\r\n.clickable-cell {\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.clickable-cell:hover {\r\n  background: #e3f2fd !important;\r\n  border-color: #2196f3 !important;\r\n}\r\n\r\n/* 선택된 셀 */\r\n.selected-cell {\r\n  background: #f8d7da !important;\r\n  border: 2px solid #dc3545 !important;\r\n  color: #721c24 !important;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.selected-cell:hover {\r\n  background: #f5c6cb !important;\r\n}\r\n\r\n.selected-cell::after {\r\n  content: '✓';\r\n  position: absolute;\r\n  top: 2px;\r\n  right: 2px;\r\n  font-size: 10px;\r\n  color: #dc3545;\r\n  font-weight: bold;\r\n}\r\n\r\n/* 클릭 가능한 헤더 */\r\n.clickable-header {\r\n  cursor: pointer;\r\n  user-select: none;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.clickable-header:hover {\r\n  background: #e9ecef !important;\r\n}\r\n\r\n/* 선택된 컬럼 헤더 */\r\n.selected-column {\r\n  background: #d1ecf1 !important;\r\n  border-color: #17a2b8 !important;\r\n  color: #0c5460 !important;\r\n  font-weight: 700;\r\n}\r\n\r\n.selected-column:hover {\r\n  background: #bee5eb !important;\r\n}\r\n\r\n.column-selected-indicator {\r\n  float: right;\r\n  margin-left: 0.5rem;\r\n  font-size: 0.8rem;\r\n  color: #17a2b8;\r\n  font-weight: bold;\r\n}\r\n\r\n.header-part {\r\n  display: block;\r\n  margin: 2px 0;\r\n  font-size: 0.8rem;\r\n  line-height: 1.2;\r\n}\r\n\r\n.sort-indicator {\r\n  float: right;\r\n  margin-left: 0.5rem;\r\n  font-size: 0.8rem;\r\n  color: #6c757d;\r\n}\r\n\r\n/* 합계 행 */\r\n.totals-row {\r\n  background: #f8f9fa !important;\r\n  font-weight: 600;\r\n}\r\n\r\n.totals-row td {\r\n  background: #f8f9fa !important;\r\n  border-top: 2px solid #495057;\r\n}\r\n\r\n.totals-label {\r\n  text-align: left !important;\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n.totals-cell {\r\n  font-weight: 600;\r\n  color: #495057;\r\n}\r\n\r\n/* 데이터 없음 메시지 */\r\n.no-data-message {\r\n  text-align: center;\r\n  padding: 3rem;\r\n  color: #666;\r\n}\r\n\r\n.no-data-message h3 {\r\n  margin: 0 0 1rem 0;\r\n  color: #333;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n.no-data-message p {\r\n  margin: 0;\r\n  color: #666;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n/* 테이블 푸터 */\r\n.table-footer {\r\n  padding: 0.75rem 1rem;\r\n  background: #f8f9fa;\r\n  border-top: 1px solid #e1e5e9;\r\n}\r\n\r\n.footer-info {\r\n  font-size: 0.8rem;\r\n  color: #666;\r\n  text-align: center;\r\n}\r\n\r\n.footer-info p {\r\n  margin: 0.25rem 0;\r\n}\r\n\r\n.clear-selection-btn {\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  padding: 0.5rem 1rem;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n  margin-top: 0.5rem;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.clear-selection-btn:hover {\r\n  background: #c82333;\r\n}\r\n\r\n/* 반응형 디자인 */\r\n@media (max-width: 768px) {\r\n  .retirement-header {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .header-buttons {\r\n    width: 100%;\r\n    justify-content: flex-end;\r\n  }\r\n  \r\n  .meta-info {\r\n    flex-direction: column;\r\n    gap: 0.5rem;\r\n  }\r\n  \r\n  .retirement-data-table {\r\n    font-size: 0.8rem;\r\n  }\r\n  \r\n  .retirement-data-table th,\r\n  .retirement-data-table td {\r\n    padding: 0.4rem 0.3rem;\r\n    min-width: 80px;\r\n  }\r\n}\r\n\r\n/* 담기 버튼 스타일 */\r\n.cart-actions {\r\n  margin-top: 1rem;\r\n  padding: 1rem;\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  border: 1px solid #e1e5e9;\r\n}\r\n\r\n.add-to-cart-btn {\r\n  width: 100%;\r\n  background: #28a745;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 6px;\r\n  padding: 0.75rem 1rem;\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.add-to-cart-btn:hover:not(:disabled) {\r\n  background: #218838;\r\n  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.3);\r\n}\r\n\r\n.add-to-cart-btn:disabled {\r\n  background: #6c757d;\r\n  cursor: not-allowed;\r\n  opacity: 0.6;\r\n}\r\n\r\n/* 스크롤바 스타일링 */\r\n.retirement-table-container::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n\r\n.retirement-table-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.retirement-table-container::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 4px;\r\n}\r\n\r\n.retirement-table-container::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n/* ── DC 부담금: 총 부담금 배지 / 재직 메타 / 경고 ── */\r\n.total-contribution-info {\r\n  background: #cfe2ff !important;\r\n  border-color: #0d6efd !important;\r\n  color: #084298 !important;\r\n  font-weight: 700;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.employment-meta {\r\n  margin-top: 0.4rem;\r\n}\r\n\r\n.no-leave-warning {\r\n  background: #fff3cd !important;\r\n  border-color: #ffc107 !important;\r\n  color: #856404 !important;\r\n  font-weight: 600;\r\n}\r\n\r\n/* ── 연도별 부담금 정산 패널 (표 가운데 정렬) ── */\r\n.yearly-summary-panel {\r\n  margin: 0.75rem 0;\r\n  overflow-x: auto;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.yearly-summary-table {\r\n  border-collapse: collapse;\r\n  font-size: 0.85rem;\r\n  min-width: 420px;\r\n  background: white;\r\n  margin: 0 auto;\r\n}\r\n\r\n.yearly-summary-table th,\r\n.yearly-summary-table td {\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.35rem 0.75rem;\r\n  text-align: center;\r\n}\r\n\r\n.yearly-summary-table th {\r\n  background: #f8f9fa;\r\n  color: #495057;\r\n  font-weight: 600;\r\n}\r\n\r\n.yearly-summary-table td.num {\r\n  text-align: right;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.yearly-summary-table tfoot td {\r\n  background: #e7f1ff;\r\n  font-weight: 700;\r\n}\r\n\r\n.inherited-tag {\r\n  display: inline-block;\r\n  margin-left: 6px;\r\n  padding: 0 5px;\r\n  font-size: 0.7rem;\r\n  font-weight: 600;\r\n  color: #856404;\r\n  background: #fff3cd;\r\n  border: 1px solid #ffc107;\r\n  border-radius: 8px;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── 산입 컬럼 (월별 산입분, 클릭 수정) ── */\r\n.share-column-header {\r\n  background: #e7f1ff !important;\r\n  min-width: 72px;\r\n  width: 72px;\r\n}\r\n\r\n.share-cell {\r\n  min-width: 72px;\r\n  width: 72px;\r\n  text-align: center;\r\n  cursor: pointer;\r\n  background: #f4f8ff;\r\n  font-variant-numeric: tabular-nums;\r\n}\r\n\r\n.share-cell:hover {\r\n  background: #dbe9ff;\r\n}\r\n\r\n.share-cell.overridden {\r\n  background: #fff3cd;\r\n  font-weight: 700;\r\n  color: #856404;\r\n}\r\n\r\n.share-cell.editing {\r\n  padding: 2px;\r\n}\r\n\r\n.share-cell.editing input {\r\n  width: 100%;\r\n  border: 2px solid #0d6efd;\r\n  border-radius: 3px;\r\n  padding: 2px 4px;\r\n  font-size: inherit;\r\n  text-align: center;\r\n}\r\n\r\n.override-mark {\r\n  margin-left: 3px;\r\n  font-size: 0.75rem;\r\n}\r\n\r\n.share-cell.totals-cell {\r\n  cursor: default;\r\n  font-weight: 700;\r\n  background: #e7f1ff;\r\n}\r\n\r\n/* ── 비고 컬럼 (월별 산입 사유 / 연도별 승계) ── */\r\n.share-note-header {\r\n  background: #f8f9fa !important;\r\n  min-width: 160px;\r\n}\r\n\r\n/* .retirement-data-table td 의 nowrap/max-width(120px)보다 명시도를 높여야 적용됨 */\r\n.retirement-data-table td.share-note-cell {\r\n  min-width: 200px;\r\n  max-width: none;\r\n  font-size: 0.78rem;\r\n  color: #6c757d;\r\n  text-align: left;\r\n  white-space: normal;   /* 내용 잘림 방지 — 줄바꿈 허용 */\r\n  word-break: keep-all;  /* 한글 어절 단위 줄바꿈 */\r\n  line-height: 1.4;\r\n}\r\n\r\n.yearly-summary-table td.note {\r\n  text-align: left;\r\n  font-size: 0.8rem;\r\n  color: #6c757d;\r\n  min-width: 160px;\r\n}\r\n\r\n/* ── 해당월 임금대장 보기 (좌측 컬럼) ── */\r\n.ledger-link-header {\r\n  background: #f8f9fa !important;\r\n  min-width: 52px;\r\n  width: 52px;\r\n}\r\n\r\n.retirement-data-table td.ledger-link-cell {\r\n  min-width: 52px;\r\n  width: 52px;\r\n  text-align: center;\r\n}\r\n\r\n.ledger-link-btn {\r\n  display: inline-block;\r\n  padding: 1px 8px;\r\n  font-size: 0.75rem;\r\n  color: #0d6efd;\r\n  background: #e7f1ff;\r\n  border: 1px solid #b6d4fe;\r\n  border-radius: 8px;\r\n  text-decoration: none;\r\n  white-space: nowrap;\r\n}\r\n\r\n.ledger-link-btn:hover {\r\n  background: #cfe2ff;\r\n}\r\n\r\n/* ── 연도 경계 굵은 선 (해가 바뀌는 행 위쪽) ── */\r\n.retirement-data-table tr.year-boundary td {\r\n  border-top: 3px solid #495057;\r\n}\r\n\r\n/* ── 가상 월 행 (입사/퇴사년도 근무기간 외) ── */\r\n.retirement-data-table tr.virtual-month-row td.virtual-cell {\r\n  background: #fafbfc;\r\n  color: #adb5bd;\r\n  font-style: italic;\r\n}\r\n\r\n/* 퇴사일이 없는 직원의 퇴사 예정일: 눈에 띄게 */\r\n.planned-leave-panel { display: flex; align-items: center; gap: 14px; flex-wrap: wrap; margin: 10px 0; padding: 12px 16px; border: 2px solid #e8590c; border-radius: 10px; background: #fff4e6; }\r\n.planned-leave-panel.set { border-color: #1864ab; background: #e7f1fb; }\r\n.planned-leave-panel > div { display: flex; flex-direction: column; gap: 3px; flex: 1; min-width: 260px; }\r\n.planned-leave-panel b { color: #9a4b00; font-size: 15px; }\r\n.planned-leave-panel.set b { color: #0b3d6b; }\r\n.planned-leave-panel span { color: #495057; font-size: 13px; }\r\n.planned-leave-panel label { display: flex; align-items: center; gap: 8px; font-weight: 700; }\r\n.planned-leave-panel input { height: 34px; padding: 0 10px; border: 2px solid #e8590c; border-radius: 6px; font: inherit; font-size: 14px; }\r\n.planned-leave-panel.set input { border-color: #1864ab; }\r\n.planned-leave-panel button { height: 34px; padding: 0 12px; border: 1px solid #adb5bd; border-radius: 6px; background: #fff; cursor: pointer; }\r\n\r\n/* 산식(한 번만)과 휴직 내역 */\r\n/* 산식: 분수 모양, 기호는 수식체 */\r\n.yearly-formula { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 18px; margin-bottom: 10px; padding: 8px 12px; border-radius: 8px; background: #f6f8fb; }\r\n.dc-math { display: inline-flex; align-items: center; gap: 4px; font-family: 'Cambria Math', 'Cambria', 'Times New Roman', serif; font-variant-numeric: tabular-nums; }\r\n.dc-main { color: #0b3d6b; font-size: 17px; }\r\n.dc-word { font-family: 'Malgun Gothic', sans-serif; font-size: 14px; font-weight: 700; }\r\n.dc-var { font-style: italic; font-weight: 600; }\r\n.dc-frac { display: inline-flex; flex-direction: column; align-items: stretch; margin: 0 3px; text-align: center; vertical-align: middle; line-height: 1.2; }\r\n.dc-num { padding: 0 5px 2px; border-bottom: 1.5px solid currentColor; }\r\n.dc-den { padding: 2px 5px 0; }\r\n.dc-legend { display: inline-flex; flex-wrap: wrap; gap: 4px 12px; color: #495057; font-size: 12px; }\r\n.dc-legend .dc-var { margin-right: 3px; color: #0b3d6b; font-family: 'Cambria Math', 'Times New Roman', serif; font-size: 14px; }\r\n.dc-cases { display: inline-flex; align-items: center; flex-wrap: wrap; gap: 4px; color: #6c757d; font-size: 12px; }\r\n.dc-cases .dc-math { font-size: 13px; color: #495057; }\r\n/* 연도별 칸: 같은 모양을 작게(행 높이를 크게 늘리지 않게) */\r\n.dc-cell { font-size: 11.5px; line-height: 1.1; color: #343a40; }\r\n.dc-cell b { font-family: 'Malgun Gothic', sans-serif; font-size: 12.5px; color: #0b3d6b; }\r\n.dc-cell .dc-num { padding-bottom: 1px; border-bottom-width: 1px; }\r\n.dc-cell .dc-den { padding-top: 1px; }\r\n.dc-note { margin-right: 4px; font-family: 'Malgun Gothic', sans-serif; color: #6c757d; font-size: 11px; }\r\n.leave-history-panel { display: flex; align-items: center; flex-wrap: wrap; gap: 6px 10px; margin: 10px 0; padding: 8px 12px; border: 1px solid #ffe066; border-radius: 8px; background: #fffbe6; }\r\n.leave-history-panel b { color: #5c4a00; }\r\n.leave-chip { padding: 2px 10px; border-radius: 12px; background: #fff3bf; color: #5c4a00; font-weight: 600; font-variant-numeric: tabular-nums; }\r\n.leave-history-note { color: #6c757d; font-size: 12px; }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
